var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFriendly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4821 25.8037H7.74107C3.47239 25.8037 0 29.2761 0 33.5448V34.835C0 35.5481 0.577053 36.1251 1.29018 36.1251H21.933C22.6462 36.1251 23.2232 35.5481 23.2232 34.835V33.5448C23.2232 29.2761 19.7508 25.8037 15.4821 25.8037Z",
    fill: "url(#paint0_linear_740_4992)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0938 0.000244141C22.1136 0.000244141 18.0625 4.05134 18.0625 9.03149C18.0625 14.0116 22.1136 18.0627 27.0938 18.0627C32.0739 18.0627 36.125 14.0116 36.125 9.03149C36.125 4.05134 32.0739 0.000244141 27.0938 0.000244141ZM32.1134 6.20923L26.9526 12.6601C26.838 12.8038 26.6679 12.8907 26.4839 12.9008C26.4726 12.902 26.46 12.902 26.4487 12.902C26.2786 12.902 26.1135 12.834 25.9926 12.713L23.4122 10.1327C23.1602 9.88069 23.1602 9.47247 23.4122 9.22048C23.6642 8.9685 24.0724 8.9685 24.3244 9.22048L26.3957 11.2906L31.1054 5.40287C31.3284 5.12442 31.7341 5.08284 32.0126 5.30207C32.291 5.52508 32.3351 5.93078 32.1134 6.20923Z",
    fill: "url(#paint1_linear_740_4992)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6083 10.3215C7.34029 10.3215 3.86719 13.7946 3.86719 18.0626C3.86719 22.3306 7.34029 25.8037 11.6083 25.8037C15.8762 25.8037 19.3493 22.3306 19.3493 18.0626C19.3493 13.7946 15.8762 10.3215 11.6083 10.3215ZM9.0279 15.4822C9.74048 15.4822 10.3181 16.0599 10.3181 16.7724C10.3181 17.4849 9.74048 18.0626 9.0279 18.0626C8.31533 18.0626 7.73772 17.4849 7.73772 16.7724C7.73772 16.0599 8.31533 15.4822 9.0279 15.4822ZM15.2822 21.7536C14.2692 22.7334 12.9387 23.2233 11.6082 23.2233C10.2777 23.2233 8.94719 22.7334 7.9342 21.7536C7.67843 21.5062 7.67087 21.0971 7.91908 20.8395C8.16602 20.5832 8.57298 20.5769 8.83127 20.8244C10.3608 22.3041 12.8555 22.3041 14.3851 20.8244C14.6434 20.5769 15.0503 20.5832 15.2973 20.8395C15.5455 21.0971 15.5379 21.5062 15.2822 21.7536ZM14.1886 18.0626C13.476 18.0626 12.8984 17.4849 12.8984 16.7724C12.8984 16.0599 13.476 15.4822 14.1886 15.4822C14.9012 15.4822 15.4788 16.0599 15.4788 16.7724C15.4788 17.4849 14.9012 18.0626 14.1886 18.0626Z",
    fill: "url(#paint2_linear_740_4992)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_4992",
    x1: 5.37311,
    y1: 31.6393,
    x2: 23.0563,
    y2: 31.6298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_4992",
    x1: 22.2416,
    y1: 10.2126,
    x2: 35.9952,
    y2: 10.2093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_4992",
    x1: 7.44926,
    y1: 19.075,
    x2: 19.2381,
    y2: 19.0722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendly);
export default __webpack_public_path__ + "static/media/user-friendly.4ab7638d8262661406908887bc1e2431.svg";
export { ForwardRef as ReactComponent };